<div class="infoRow col-md-12" *ngIf="selectedHeader=='billingDetails'">
    <p>Organizations can only be registered once. If your organization has registered with  {{ baseSiteId == "vax" ? "VaxServe" : "VaccineShop"}}, you should 
        <a class="" (click)="gotoAdduser()" href="javascript: void(0);">
            create a new user account instead.
        </a>
    </p>
    <span>
        Not sure whether your organization is registered?
    </span>
        <p>
            <a *ngIf="baseSiteId != 'vax'" class="mailTo" href="mailto:vaccineshoppe.svc@sanofi.com">We can help.</a>
            <a *ngIf="baseSiteId == 'vax'" class="mailTo" href="mailto:VaxServe@vaxserve.com">We can help.</a>
        </p>   
</div>

<div class="row">
<div class="Registration-nav col-12 p0 multipleHeader">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 payment">
        <div class="Common-registration" [ngClass]="selectedHeader=='billingDetails'?'Common-active':''">
            <span>1</span>
            <span>{{ "accountRegistration.shippingInformation.header" | cxTranslate }}</span>
        </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
        <div class="Common-registration" [ngClass]="selectedHeader=='shippingDetails'?'Common-active':''">
            <span>2</span>
            <span>{{ "accountRegistration.billingInformation.header" | cxTranslate }}</span>
        </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
        <div class="Common-registration" [ngClass]="selectedHeader=='contacts'?'Common-active':''">
            <span>3</span>
            <span>{{ "accountRegistration.contactsInformation.header" | cxTranslate }}</span>
        </div>
    </div>
    <div class="col-xs-12 col-md-12 col-lg-3 confirmation">
        <div class="Common-registration" [ngClass]="selectedHeader==null?'Common-active':''">
            <span>4</span>
            <span>{{ "accountRegistration.accountConfirmation.header" | cxTranslate }}</span>
        </div>
    </div>
</div>
<div class="col-md-12 col-12 brdr3Style p-0 m-0">
    <!-- <span class="NeedAss" *ngIf="header!='shippingDetails'">Need assistance?</span>
    <p class="NeedAssP" *ngIf="header=='shippingDetails'">The following states have sales tax on vaccines:</p> -->
    <div *ngIf="selectedHeader=='shippingDetails'" class="Registration-nav singleHeader">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
            <div class="Common-registration" [ngClass]="selectedHeader=='shippingDetails'?'Common-active':''">
                <span>2</span>
                <span>{{ "accountRegistration.billingInformation.header" | cxTranslate }}</span>
            </div>
        </div>
    </div>
    <div *ngIf="selectedHeader=='billingDetails'" class="Registration-nav singleHeader">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 payment">
            <div class="Common-registration" [ngClass]="selectedHeader=='billingDetails'?'Common-active':''">
                <span>1</span>
                <span>{{ "accountRegistration.shippingInformation.header" | cxTranslate }}</span>
            </div>
        </div>
    </div>
    <div *ngIf="selectedHeader=='contacts'" class="Registration-nav singleHeader">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
            <div class="Common-registration" [ngClass]="selectedHeader=='contacts'?'Common-active':''">
                <span>3</span>
                <span>{{ "accountRegistration.contactsInformation.header" | cxTranslate }}</span>
            </div>
        </div>
    </div>
    <div *ngIf="selectedHeader=='confirmation'" class="Registration-nav singleHeader confirmation">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
            <div class="Common-registration" [ngClass]="selectedHeader=='confirmation'?'Common-active':''">
                <span>4</span>
                <span>{{ "accountRegistration.accountConfirmation.header" | cxTranslate }}</span>
            </div>
        </div>
    </div>
</div>
</div>